import {
  matchesGvQueryEntry
} from "./chunk-HZ3TCGBK.js";
import {
  mclass
} from "./chunk-IZUYLFOX.js";

// ../shared/utils/dist/src/termCollection.js
function validateTermCollectionTerm(term) {
  if (!Array.isArray(term?.termlst) || !term.termlst.length)
    throw new Error("termCollection requires nonempty term.termlst[]");
  const memberIds = /* @__PURE__ */ new Set();
  const types = /* @__PURE__ */ new Set();
  for (const t of term.termlst) {
    if (typeof t.id != "string" || !t.id) throw new Error("member term id not non-empty string");
    if (typeof t.type != "string" || !t.type) throw new Error("member term type not non-empty string");
    if (memberIds.has(t.id)) throw new Error(`duplicate member term id '${t.id}'`);
    memberIds.add(t.id);
    types.add(t.type == "integer" || t.type == "float" ? "numDict" : t.type);
  }
  if (types.size > 1) throw new Error("termCollection.termlst[] not allowed to mix multiple term types");
  return memberIds;
}
function validateFractionMembers(numerators, denominators, memberIds) {
  if (!Array.isArray(denominators) || !denominators.length) throw new Error("fraction requires nonempty denominators[]");
  if (!Array.isArray(numerators) || !numerators.length) throw new Error("fraction requires nonempty numerators[]");
  if (new Set(denominators).size !== denominators.length) throw new Error("fraction denominators[] contains duplicates");
  if (new Set(numerators).size !== numerators.length) throw new Error("fraction numerators[] contains duplicates");
  for (const id of denominators) {
    if (typeof id != "string" || !id) throw new Error("fraction denominator id not non-empty string");
    if (!memberIds.has(id)) throw new Error(`fraction denominator '${id}' is not a collection member`);
  }
  for (const id of numerators) {
    if (typeof id != "string" || !id) throw new Error("fraction numerator id not non-empty string");
    if (!denominators.includes(id)) throw new Error(`fraction numerator '${id}' is not included in denominators[]`);
  }
}
var FRACTION_TW_TYPE = "TermCollectionTWFraction";
function isFractionTw(tw) {
  return tw?.type === FRACTION_TW_TYPE && tw?.term?.type === "termCollection";
}
function getFractionTvsTerm(tw) {
  if (!isFractionTw(tw)) throw new Error("not a fraction termCollection tw");
  const term = structuredClone(tw.term);
  const memberIds = term.termlst?.length ? validateTermCollectionTerm(term) : new Set(term.termIds || []);
  const denominators = tw.q?.denominators?.length ? [...tw.q.denominators] : [...memberIds];
  const numerators = tw.q?.numerators?.length ? [...tw.q.numerators] : [...denominators];
  validateFractionMembers(numerators, denominators, memberIds);
  term.numerators = numerators;
  term.denominators = denominators;
  return term;
}
function validateTermCollectionFraction(q, term) {
  const memberIds = validateTermCollectionTerm(term);
  validateFractionMembers(q?.numerators, q?.denominators, memberIds);
  if (q.mode === "discrete" && q.type !== "regular-bin" && q.type !== "custom-bin")
    throw new Error("discrete fraction termCollection requires regular-bin or custom-bin q.type");
}

// ../shared/utils/dist/src/filter.js
function getFilteredSamples(sampleAnno, filter) {
  setDatasetAnnotations(filter);
  const samples = /* @__PURE__ */ new Set();
  for (const anno of sampleAnno) {
    if (samples.has(anno.sample)) continue;
    const data = anno.s || anno.data;
    if (data && sample_match_termvaluesetting(data, filter)) {
      samples.add(anno.sample);
    }
  }
  return samples;
}
function sample_match_termvaluesetting(row, filter, _term = null, sample = null) {
  const lst = filter.type == "tvslst" ? filter.lst : [filter];
  let numberofmatchedterms = 0;
  for (const item of lst) {
    if ("type" in item && item.type == "tvslst") {
      if (sample_match_termvaluesetting(row, item, _term, sample)) {
        numberofmatchedterms++;
      }
    } else {
      const itemCopy = JSON.parse(JSON.stringify(item));
      const t = itemCopy.tvs;
      if (_term && t.term) {
        if (!(_term.name == t.term.name && _term.type == t.term.type)) {
          numberofmatchedterms++;
          continue;
        }
      }
      let samplevalue;
      if (_term && !t.term) {
        if (t.term$type && t.term$type !== _term.type) {
          numberofmatchedterms++;
          continue;
        }
        t.term = _term;
        samplevalue = typeof row === "object" && t.term.id in row ? row[t.term.id] : row;
      } else if (sample && t.term.$id) {
        samplevalue = sample[t.term.$id].value;
      } else {
        samplevalue = t.term.id in row ? row[t.term.id] : row;
      }
      setDatasetAnnotations(itemCopy);
      let thistermmatch;
      if (t.term.type == "categorical") {
        if (samplevalue === void 0) continue;
        thistermmatch = t.valueset.has(samplevalue);
      } else if (t.term.type == "integer" || t.term.type == "float") {
        if (samplevalue === void 0) continue;
        for (const range of t.ranges) {
          if ("value" in range) {
            thistermmatch = samplevalue === range.value;
            if (thistermmatch) break;
          } else if (samplevalue == range.name) {
            thistermmatch = true;
            break;
          } else {
            if (t.term.values) {
              const v = t.term.values[samplevalue.toString()];
              if (v && v.uncomputable) {
                continue;
              }
            }
            let left, right;
            if (range.startunbounded) {
              left = true;
            } else if ("start" in range) {
              if (range.startinclusive) {
                left = samplevalue >= range.start;
              } else {
                left = samplevalue > range.start;
              }
            }
            if (range.stopunbounded) {
              right = true;
            } else if ("stop" in range) {
              if (range.stopinclusive) {
                right = samplevalue <= range.stop;
              } else {
                right = samplevalue < range.stop;
              }
            }
            thistermmatch = left && right;
          }
          if (thistermmatch) break;
        }
      } else if (t.term.type == "condition") {
        const key = getPrecomputedKey(t);
        const anno = samplevalue && samplevalue[key];
        if (anno) {
          thistermmatch = Array.isArray(anno) ? t.values.find((d) => anno.includes(d.key)) : t.values.find((d) => d.key == anno);
        }
      } else if (t.term.type == "geneVariant") {
        const svalues = samplevalue.values || [samplevalue];
        for (const sv of svalues) {
          thistermmatch = t.values.find(
            (v) => v.dt == sv.dt && (!v.origin || sv.origin == v.origin) && (!v.mclasslst || v.mclasslst.includes(sv.class))
          ) && true;
          if (thistermmatch) break;
        }
      } else {
        throw "unknown term type [sample_match_termvaluesetting() shared/utils/src/filter.ts]";
      }
      if (t.isnot) {
        thistermmatch = !thistermmatch;
      }
      if (thistermmatch) numberofmatchedterms++;
    }
    if (filter.join == "or") {
      if (numberofmatchedterms && filter.in) return true;
      if (!numberofmatchedterms && !filter.in) return true;
    }
  }
  if (!("in" in filter)) filter.in = true;
  return filter.in == (numberofmatchedterms == lst.length);
}
function setDatasetAnnotations(item, ds = null) {
  if (item.type == "tvslst") {
    for (const subitem of item.lst) {
      setDatasetAnnotations(subitem, ds);
    }
  } else {
    if (ds && typeof ds.setAnnoByTermId == "function") {
      ds.setAnnoByTermId(item.tvs.term.id);
    }
    if (item.tvs.term.type == "categorical") {
      const tvsAny = item.tvs;
      tvsAny.valueset = new Set(tvsAny.values.map((i) => i.key));
    }
  }
}
function getPrecomputedKey(q) {
  const precomputedKey = q.bar_by_children && q.value_by_max_grade ? "childrenAtMaxGrade" : q.bar_by_children && q.value_by_most_recent ? "childrenAtMostRecent" : q.bar_by_children && q.value_by_computable_grade ? "children" : q.bar_by_grade && q.value_by_max_grade ? "maxGrade" : q.bar_by_grade && q.value_by_most_recent ? "mostRecentGrades" : q.bar_by_grade && q.value_by_computable_grade ? "computableGrades" : "";
  if (!precomputedKey) throw `unknown condition term bar_by_* and/or value_by_*`;
  return precomputedKey;
}
function getWrappedTvslst(lst = [], join = "", $id = null) {
  const filter = {
    type: "tvslst",
    in: true,
    join,
    lst
  };
  if ($id !== null) filter.$id = $id;
  return filter;
}
function getTvsDenominators(term) {
  if (Array.isArray(term?.denominators) && term.denominators.length) return term.denominators;
  return (term?.termlst || []).map((t) => t.id);
}
function validateTermCollectionTvs(term) {
  const memberIds = validateTermCollectionTerm(term);
  if (!term.numerators) return;
  validateFractionMembers(term.numerators, getTvsDenominators(term), memberIds);
}

// ../shared/utils/dist/src/geneVariantFilter.js
var statusClasses = /* @__PURE__ */ new Set(["WT", "Blank"]);
function unsupported(what) {
  return `tw.q.variantFilter does not support ${what}, which qualifies a sample rather than an individual variant. Use a groupset (q.type='custom-groupset') for a sample-level filter.`;
}
function validateVariantFilter(filter, term) {
  if (!filter) return;
  if (filter.type != "tvslst") throw `tw.q.variantFilter.type must be 'tvslst'`;
  if (!Array.isArray(filter.lst) || !filter.lst.length) throw "tw.q.variantFilter.lst[] is empty";
  if (filter.lst.length > 1 && filter.join != "and" && filter.join != "or")
    throw `tw.q.variantFilter.join must be 'and' or 'or' when lst[] has more than one item`;
  const dts = term?.childTerms?.length ? new Set(term.childTerms.map((t) => t.dt)) : null;
  for (const item of filter.lst) {
    if (item.type == "tvslst") {
      validateVariantFilter(item, term);
      continue;
    }
    if (item.type != "tvs") throw `unexpected tw.q.variantFilter item.type='${item.type}'`;
    const tvs = item.tvs;
    if (!tvs) throw "missing tvs of a tw.q.variantFilter item";
    if (!Number.isInteger(tvs.term?.dt)) throw "tw.q.variantFilter tvs.term must be a dt term, with an integer .dt";
    if (dts && !dts.has(tvs.term.dt))
      throw `tw.q.variantFilter tvs.term.dt=${tvs.term.dt} is not a dt of term '${term.name}'`;
    if (!Array.isArray(tvs.values) || !tvs.values.length) throw "tw.q.variantFilter tvs.values[] is empty";
    for (const v of tvs.values) {
      if (!v.key) throw "a tw.q.variantFilter tvs.values[] entry is missing .key";
      if (statusClasses.has(v.key))
        throw `tw.q.variantFilter cannot select the '${v.key}' class, which is a testing status and not a variant`;
      if (v.partnerBreakpointRange) throw unsupported("partnerBreakpointRange");
    }
    if (tvs.genotype && tvs.genotype != "variant") throw unsupported(`genotype='${tvs.genotype}'`);
    if (tvs.mcount && tvs.mcount != "any") throw unsupported(`mcount='${tvs.mcount}'`);
    if (tvs.mafFilter) throw unsupported("mafFilter");
    if (tvs.continuousCnv) throw unsupported("continuousCnv");
    if (tvs.selfBreakpointRange) throw unsupported("selfBreakpointRange");
  }
}
function getFilterScope(filter, scope = /* @__PURE__ */ new Set()) {
  for (const item of filter.lst) {
    if (item.type == "tvslst") getFilterScope(item, scope);
    else scope.add(`${item.tvs.term.dt}:${item.tvs.term.origin || "*"}`);
  }
  return scope;
}
function isInScope(v, scope) {
  return scope.has(`${v.dt}:*`) || scope.has(`${v.dt}:${v.origin || ""}`);
}
function matchTvs(v, tvs) {
  let match = false;
  if (v.dt == tvs.term.dt && (!tvs.term.origin || v.origin == tvs.term.origin)) {
    match = tvs.values.some((e) => e.key == v.class && (!e.mname || e.mname == v.mname && matchesGvQueryEntry(e, v)));
  }
  return tvs.isnot ? !match : match;
}
function matchFilter(v, filter) {
  const lst = filter.type == "tvslst" ? filter.lst : [filter];
  let numMatched = 0;
  for (const item of lst) {
    const matched = item.type == "tvslst" ? matchFilter(v, item) : matchTvs(v, item.tvs);
    if (matched) numMatched++;
    if (filter.join == "or" && numMatched) break;
  }
  const pass = filter.join == "or" ? numMatched > 0 : numMatched == lst.length;
  return filter.in === false ? !pass : pass;
}
function filterVariantValues(values, filter) {
  if (!filter || !values) return values;
  const scope = getFilterScope(filter);
  const kept = [];
  const annotated = /* @__PURE__ */ new Set();
  const dropped = /* @__PURE__ */ new Map();
  for (const v of values) {
    if (!isInScope(v, scope)) continue;
    const key = `${v.dt}:${v.origin || ""}`;
    if (statusClasses.has(v.class) || matchFilter(v, filter)) {
      kept.push(v);
      annotated.add(key);
    } else if (!dropped.has(key)) {
      dropped.set(key, v);
    }
  }
  for (const [key, v] of dropped) {
    if (annotated.has(key)) continue;
    const wt = { dt: v.dt, class: "WT", label: mclass.WT.label };
    if (v.gene) wt.gene = v.gene;
    if (v.origin) wt.origin = v.origin;
    kept.push(wt);
  }
  return kept;
}
function variantFilterLabel(filter, mclassOverride, maxItems = 3) {
  if (!filter) return "";
  const entries = [];
  collect(filter, false);
  function collect(f, negated) {
    const flipped = f.in === false ? !negated : negated;
    for (const item of f.lst) {
      if (item.type == "tvslst") collect(item, flipped);
      else if (flipped === !!item.tvs.isnot) entries.push(...item.tvs.values);
    }
  }
  if (!entries.length) return "";
  const classes = mclass;
  const names = [
    ...new Set(entries.map((e) => e.mname || mclassOverride?.[e.key]?.label || classes[e.key]?.label || e.key))
  ];
  return names.length > maxItems ? `${names.slice(0, maxItems).join("/")}\u2026` : names.join("/");
}

export {
  isFractionTw,
  getFractionTvsTerm,
  validateTermCollectionFraction,
  getFilteredSamples,
  sample_match_termvaluesetting,
  getWrappedTvslst,
  getTvsDenominators,
  validateTermCollectionTvs,
  validateVariantFilter,
  filterVariantValues,
  variantFilterLabel
};
//# sourceMappingURL=chunk-7CJKL3LK.js.map
